<template>
    <div class="main">
        <activitiesBanner></activitiesBanner>
        <immersiveTour v-show="viewportWidth > 799"></immersiveTour>
        <immersiveBanner v-show="viewportWidth <= 799"></immersiveBanner>
        <montageImg :sightseeingInfo="sampleActivitiesInfo" :viewportWidth="String(viewportWidth)"></montageImg>
        <footerComponent></footerComponent>
    </div>
</template>
<script>
import activitiesBanner from '/components/pc/headerComponent/activitiesBanner.vue'
import immersiveTour from '/components/pc/experience/activities/immersiveTour.vue'
import immersiveBanner from '/components/phone/experience/activities/immersiveBanner.vue'
import montageImg from '/components/pc/experience/montageImg/montageImg.vue'
import sampleActivities from '/js/experience/activities/sampleActivities.js'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
export default{
    components:{
        activitiesBanner,
        immersiveTour,
        immersiveBanner,
        montageImg,
        footerComponent
    },
    data(){
        return {
            sampleActivitiesInfo:sampleActivities.sampleActivitiesInfo,
            viewportWidth:0
        }
    },
    mounted(){
        this.viewportWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
    },
    methods:{
        handleResize(){
            this.viewportWidth = window.innerWidth;
        }
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>
<style scoped lang="scss">
</style>